import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sidebar-home",
  "use": "icon-sidebar-home-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-sidebar-home\">\r\n<style type=\"text/css\">\r\n\t#icon-sidebar-home .st0{fill:#02b28e;}\r\n</style>\r\n<path class=\"st0\" d=\"M95.8,8.3L4.2,100h25v75c0,8.3,8.3,16.7,16.7,16.7h16.7h8.3c5,0,8.3-3.3,8.3-8.3V175v-8.3v-25\r\n\tc0-5,3.3-8.3,8.3-8.3h25c5,0,8.3,3.3,8.3,8.3v16.7V175v8.3c0,5,3.3,8.3,8.3,8.3h8.3h16.7c8.3,0,16.7-8.3,16.7-16.7v-75h25L95.8,8.3z\r\n\t\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol